import { panelRangeSharedProps as r, panelSharedProps as o } from "./index935.js";
import { buildProps as p } from "./index601.js";
const n = p({
  ...o,
  ...r
});
export {
  n as panelDateRangeProps
};
